import { render, staticRenderFns } from "./VFeatureBlock.vue?vue&type=template&id=3e1139c8&scoped=true"
import script from "./VFeatureBlock.vue?vue&type=script&lang=js"
export * from "./VFeatureBlock.vue?vue&type=script&lang=js"
import style0 from "./VFeatureBlock.vue?vue&type=style&index=0&id=3e1139c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1139c8",
  null
  
)

export default component.exports